import React, { useState, useCallback } from 'react';

import { Grid, View } from '@gogame/components';
import { useChildComponent } from '@gogame/hooks-ts';

import { useStyles } from 'scenes/PlayersActivities/sharedStyles';

import Results from '../components/Results';
import EditActivityForm from './EditActivityForm';
import LastActivityForm from './LastActivityForm';
import { useLastActivityResults, useUpdateActivity } from './data';

export default () => {
  const classes = useStyles();
  const [params, setParams] = useState();
  const { data, isLoading, isRefetching } = useLastActivityResults(params, {
    enabled: !!params,
  });

  const [updateActivity, { isLoading: updating }] = useUpdateActivity();

  const [childComponent, openChildComponent] = useChildComponent();

  const handleSubmit = useCallback(
    (values) => {
      setParams(values);
    },
    [setParams]
  );

  const handleSubmitEdit = async (values) => {
    await updateActivity({ ...values, characterId: data?.results[0]?.id });
  };

  const handleEdit = (record) => {
    openChildComponent(EditActivityForm, {
      record,
      onSubmit: handleSubmitEdit,
    });
  };

  return (
    <React.Fragment>
      <Grid container className={classes.root}>
        <Grid item xs={3} className={classes.sidebar}>
          <LastActivityForm
            onSubmit={handleSubmit}
            isLoading={isLoading || isRefetching || updating}
          />
        </Grid>
        <Grid item xs={9} className={classes.content}>
          <View loading={isLoading || updating} fetching={isRefetching}>
            <Results
              data={data}
              isLoading={isLoading || isRefetching || updating}
              onEdit={handleEdit}
            />
          </View>
        </Grid>
      </Grid>
      {childComponent}
    </React.Fragment>
  );
};
